import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

export const GoogleCodesForm = ({ onSaved }) => {
  const [clientId, setClientId] = useState('');
  const [secret, setSecret] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/api/gmail/config`, { client_id: clientId.trim(), client_secret: secret.trim() });
      toast.success('Codes Google enregistrés');
      setClientId(''); setSecret('');
      onSaved();
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Codes invalides');
    } finally { setSaving(false); }
  };

  return (
    <div className="mt-5 space-y-3 text-left" data-testid="gmail-codes-form">
      <p className="text-sm font-semibold text-slate-800">1. Collez vos 2 codes Google</p>
      <div>
        <label className="text-xs text-slate-500">ID client (finit par .apps.googleusercontent.com)</label>
        <Input value={clientId} onChange={(e) => setClientId(e.target.value)} placeholder="xxxx.apps.googleusercontent.com" data-testid="gmail-client-id-input" />
      </div>
      <div>
        <label className="text-xs text-slate-500">Code secret client (commence par GOCSPX-)</label>
        <Input type="password" value={secret} onChange={(e) => setSecret(e.target.value)} placeholder="GOCSPX-…" data-testid="gmail-client-secret-input" />
      </div>
      <Button onClick={save} disabled={saving || !clientId || !secret} className="w-full bg-[#1B3170] hover:bg-[#13245a]" data-testid="gmail-codes-save">
        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Enregistrer les codes'}
      </Button>
    </div>
  );
};
